import request from '@/lib/api'

const _BASE = "/api";
//=============================服务提供者=========================

// 服务提供者管理==服务提供者列表（搜索以及分页）
export function getServeProerlist(params) {
  return request({
    url: `${_BASE}/tPmcProviders/providers`,
    method: 'get',
    params
  })
}
// 服务提供者管理==服务提供者列表==已发布服务
export function getServePubilshlist(params, id) {
  return request({
    url: `${_BASE}/tPmcProviders/providers/services/${id}`,
    method: 'get',
    params
  })
}
// 服务提供者管理==服务提供者列表==服务提供者详情
export function getServeProerDetail(id) {
  return request({
    url: `${_BASE}/tPmcProviders/providers/${id}`,
    method: 'get',
  })
}
//=============================服务提供者审核=========================

// 服务提供者管理==服务提供者审核列表（搜索以及分页）
export function getServeProerChecklist(params) {
  return request({
    url: `${_BASE}/tPmcProviders/auditList`,
    method: 'get',
    params
  })
}
// 服务提供者管理==服务提供者审核列表==服务提供者详情
export function getServeProerCheckDetail(id) {
  return request({
    url: `${_BASE}/tPmcProviders/audit/${id}`,
    method: 'get',
  })
}

// 服务提供者管理==服务提供者详情==驳回
export function serveProerCheckReturn(id, params) {
  return request({
    url: `${_BASE}/tPmcProviders/reject/${id}`,
    method: 'put',
    params
  })
}
// 服务管理==服务上架审核列表==审核通过
export function serveProerCheckPass(id) {
  return request({
    url: `${_BASE}/tPmcProviders/audit/${id}`,
    method: 'put',
  })
}

//获取版本详情
export function getVersion(id) {
  return request({
    url: `${_BASE}/tPmcServiceV3/service_version/${id}`,
    method: 'get',
  })
}